import { Route } from 'react-router';
import { DashboardPage } from '../DashboardPage';
import { getDashboardPath } from '../path/path';

export const DashboardRoutes = [
  <Route key={getDashboardPath()} path={getDashboardPath()} element={<DashboardPage />} />,
];
